import "../scss/main.scss";

/**
 * Front-end JavaScript
 *
 * The JavaScript code you place here will be processed by esbuild. The output
 * file will be created at `../theme/js/script.min.js` and enqueued in
 * `../theme/functions.php`.
 *
 * For esbuild documentation, please see:
 * https://esbuild.github.io/
 */

import menuSticky from "./menu-sticky.js";
import menuToggle from "./menu-toggle.js";
import goToAnchor from "./goToAnchor.js";
import headerHeight from "./headerHeight.js";
import { modal } from "./modal.js";
import { moveUpElements } from "./moveUpElements.js";

import customSelect from "custom-select";

addEventListener("DOMContentLoaded", (event) => {
	document.documentElement.classList.remove("no-js");
	document.documentElement.classList.add("loaded");

	// play video on click
	const video = document.querySelector(".wp-block-cover video");
	if (video) {
		document.documentElement.addEventListener("click", () => {
			document.querySelector(".wp-block-cover video").play();
		});
	}

	menuSticky();
	menuToggle();
	headerHeight();
	modal();
	moveUpElements();

	addEventListener("scroll", (event) => {
		menuSticky();
	});

	//custom select
	customSelect("select");

	// permet de faire en sorte qu'il n'y ai pas d'orphelin à la ligne
	const gutenberg_query = document.querySelectorAll(".query-one-line");

	if (gutenberg_query) {
		gutenberg_query.forEach(function (item) {
			if (item.classList.contains("columns-4")) {
				if (item.childElementCount % 4 == 0) {
					item.lastChild.classList.add("responsive-hidden");
				}
			}

			if (item.classList.contains("columns-5")) {
				if (item.childElementCount % 5 == 0) {
					item.lastChild.classList.add("responsive-hidden");
				}
			}

			if (item.classList.contains("columns-3")) {
				if (item.childElementCount % 3 == 0) {
					item.lastChild.classList.add("responsive-hidden");
				}
			}
		});
	}

	goToAnchor();
});
